import { MoreLikeThisOptions } from "./MoreLikeThisOptions.js";

export abstract class MoreLikeThisBase {
    public options: MoreLikeThisOptions;
}
